import { React, useState, useContext } from 'react'
import BannerBuilder from './containers/bannerBuilder/BannerBuilder.js'
import './App.css'
import Navbar from './containers/navbar/Navbar.js'
import { Footer } from './containers/footer/footer.js'
import { CanvasContext } from './helpers/context/Context.js'
import { useEffect } from 'react';


const App = () => {

  useEffect(() => {
    // scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  const [canvas, setCanvas] = useState('');
  const [IsPageEnabled, setIsPageEnabled] = useState(false);
  return (
    <div className='App'>
      <div className="bg-video">
        <video id="pageBackground_c1dmp_video" autoPlay muted loop className="K8MSra" role="presentation" crossOrigin="anonymous" playsInline="" preload="auto" tabIndex="-1" src="https://video.wixstatic.com/video/f878f0_816868b839a248e7a0ca92532311c94c/720p/mp4/file.mp4" width="100%"></video>
        {/* <video id="background-video" autoplay loop muted poster="https://assets.codepen.io/6093409/river.jpg" src="https://assets.codepen.io/6093409/river.mp4" type="video/mp4">
        
        </video> */}
      </div>
      <CanvasContext.Provider value={{ canvas, setCanvas, IsPageEnabled, setIsPageEnabled }}>
        <Navbar />
        <div className='content'>
          <BannerBuilder />
        </div>
        <Footer />
      </CanvasContext.Provider>
    </div>
  )
}

export default App